import request from './http'
const baseUrl = '/apass-base'
const businessUrl = '/apass-business'
// 变更消息状态，全部已读
export const viewAll = () =>
  request({
    url: businessUrl + '/api/message/inner/viewByOneKey',
    method: 'get',
  })
// 消息未读数  
export const getMessageUnview = () =>
  request({
    hiddenMask: true,
    url: businessUrl + '/api/message/inner/count/unView',
    method: 'get'
  })
export const createApp = (data: any) =>
  request({
    url: baseUrl + '/api/application/insert',
    method: 'post',
    data
  })
export const getApplication = (data: any) =>
  request({
    url: baseUrl + '/api/application/all',
    method: 'get',
    params: data
  })
export const deltetApplicationById = (data: any) =>
  request({
    url: baseUrl + '/api/application/delete/' + data.id,
    method: 'post'
  })
export const editApplicationById = (data: any) =>
  request({
    url: baseUrl + '/api/application/update',
    method: 'post',
    data
  })
// 我的待办  
export const getUndoList = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/items/undo/list',
    method: 'get',
    params: data
  })
// 审批详情  
export const getUndoDetail = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/items/undo/detail',
    method: 'get',
    params: data
  })
// 与我相关  
export const getMineList = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/items/mine/list',
    method: 'get',
    params: data
  })
export const refreshMineItem = (processId) =>
  request({
    url: businessUrl + `/api/workFlow/items/mine/refresh/${processId}`,
    method: 'get'
  })
export const refreshUndoItem = (data) =>
  request({
    url: businessUrl + `/api/workFlow/items/undo/getUndoIds`,
    method: 'get',
    params: data
  })
// 审批通过 
export const approvalPass = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/approval/pass',
    method: 'post',
    data
  })
// 审批拒绝 
export const approvalRefuse = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/approval/refuse',
    method: 'post',
    data
  })
// 审批拒绝 
export const approvalRollback = (data: any) =>
  request({
    url: businessUrl + '/api/workFlow/approval/rollback',
    method: 'post',
    data
  })
export const changeMessageStatus = (data: any) =>
  request({
    url: businessUrl + '/api/message/inner/changeStatus',
    method: 'post',
    data
  })
export const changeUndoFocuse = (data) =>
  request({
    url: businessUrl + `/api/workFlow/items/undo/focus`,
    method: 'post',
    data
  })
// 消息中心列表 
export const getMessageList = (data: any) =>
  request({
    url: businessUrl + '/api/message/inner/list',
    method: 'post',
    data
  })
// 通过id获取消息详情 
export const getMessageById = (id: any) =>
  request({
    url: businessUrl + `/api/message/inner/findOne/${id}`,
    method: 'get',
  })  
export const getMineNums = () =>
  request({
    url: businessUrl + '/api/workFlow/items/statistics',
    method: 'get',
  })
// 判断是否能跳转到记录详情  
export const checkNoticeCanJump = (data) =>
request({
  url: businessUrl + '/api/noticeJump/checkNoticeCanJump',
  method: 'post',
  data
})
